<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.sort" placeholder="请选择" size="small">
                        <el-option label="优先展示最新日期的" :value="9"></el-option>
                        <el-option label="优先展示PV最高的" :value="1"></el-option>
                        <el-option label="优先展示UV最高的" :value="2"></el-option>
                        <el-option label="优先展示注册人数最高的" :value="3"></el-option>
                        <el-option label="优先展示订单数最高的" :value="4"></el-option>
                        <el-option label="优先展示下单人数最高的" :value="5"></el-option>
                        <el-option label="优先展示销售额最高的" :value="6"></el-option>
                        <el-option label="优先展示注册转化率最高的" :value="7"></el-option>
                        <el-option label="优先展示下单转化率最高的" :value="8"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                 <el-table-column prop="date" label="日期" min-width="100">
                </el-table-column>
                <el-table-column prop="channelName" label="渠道名称" min-width="100" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="objectType" label="对象类型">
                    <template slot-scope="scope">
                        {{objectType[scope.row.objectType]}}
                    </template>
                </el-table-column>
                <el-table-column prop="objectId" label="对象ID">
                </el-table-column>
                <el-table-column prop="pv" label="PV">
                </el-table-column>
                <el-table-column prop="uv" label="UV">
                </el-table-column>
                <el-table-column prop="registerNum" label="注册人数">
                </el-table-column>
                <el-table-column prop="orderNum" label="订单数">
                </el-table-column>
                <el-table-column prop="orderUser" label="下单人数">
                </el-table-column>
                <el-table-column prop="orderAmount" label="销售额">
                </el-table-column>
                <el-table-column prop="registerCr" label="注册转化率" min-width="90">
                    <template slot-scope="scope">
                        {{(scope.row.registerCr * 100).toFixed(1)}}%
                    </template>
                </el-table-column>
                <el-table-column prop="orderCr" label="下单转化率" min-width="90">
                    <template slot-scope="scope">
                        {{(scope.row.orderCr * 100).toFixed(1)}}%
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/report/channel/visitDetailList')"
                            type="text"
                            size="small"
                            icon="el-icon-view"
                            @click="view(scope.row)"
                            >访问明细</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>
<script>
const defaultParams = {
    channelId:"",
    objectId: "",
    pageNo:1,
    sort:9,
    startTime:'',
    endTime:'',
    // queryType: 1,
    // queryValue: "",
    objectType: "",
    // trackPath:"",
    // channelName:"",
}
export default {
    props:{
        channelId: {
            type: [Number,String]
        },
        objectId: {
            type: [Number,String]
        }
    },
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                // sort:parseInt(this.$route.query.sort || 9),
                startTime: this.$route.query.startTime,
                endTime: this.$route.query.endTime,
                // queryType:parseInt(this.$route.query.queryType || 1),
                // queryValue: this.$route.query.queryValue || "",
                objectType:parseInt(this.$route.query.objectType) || "",
                // trackPath: this.$route.query.trackPath || "",
                // channelName: this.$route.query.channelName || '',
            },
            listLoading: true,
        }
    },
    computed:{
        objectType(){
            return {
                1: '艺人',
                2: '场地',
                3: '厂牌',
                4: '演出',
                5: '巡演',
                7: '乐迷',
                99: '其他'
            }
        }
    },
    mounted() {
        this.params.objectId = this.objectId;
        this.params.channelId = this.channelId;
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            console.log(this.params)
            this.listLoading = true;
            this.params = {
                ...this.params,
            }
            this.$request({
                url: "/report/channel/channelTimeList",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
                startTime: this.params.startTime,
                endTime: this.params.endTime,
                objectId: this.params.objectId,
                channelId: this.params.channelId,
                objectType: this.params.objectType,
            };
            this.getDataList();
        },
        //访问明细
        view(item){
            this.$router.push({
                path: `/report/channel/accessDetails/list`,
                query: {
                    ...this.params,
                    startTime: item.date,
                    endTime: item.date,
                    // accessId: item.objectId,
                    accessType: item.objectType,
                    // queryValue: item.objectId,
                    // queryType: 1
                },
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>